getInternalCollectionState